import { render, staticRenderFns } from "./AccionesDisciplinarias.vue?vue&type=template&id=7cee1b91&scoped=true"
import script from "./AccionesDisciplinarias.vue?vue&type=script&lang=js"
export * from "./AccionesDisciplinarias.vue?vue&type=script&lang=js"
import style0 from "./AccionesDisciplinarias.vue?vue&type=style&index=0&id=7cee1b91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cee1b91",
  null
  
)

export default component.exports